import { useUser } from '@app/context/UserContext';
import {
  attributionVariables,
  captureAttribution,
  isAttributionSynced,
  markAttributionSynced,
} from '@app/utils/attribution';
import { useUpdateUtmParamsMutation } from '@dieterApi/company/useCompanyUpdateUtmParamsMutation';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export function ConversionTracker() {
  const location = useLocation();
  const { user, userLoading } = useUser();
  const history = useHistory();
  const [conversionTracked, setConversionTracked] = useState(false);
  const queryParams = new URLSearchParams(location.search);
  const ordervalue = queryParams.get('ordervalue');
  const session_id = queryParams.get('session_id');
  const items = queryParams.get('items');

  const [updateUtmParams] = useUpdateUtmParamsMutation();

  // push history change to google analytics
  useEffect(() => {
    return history.listen((location) => {
      // Ensure the GTM function exists
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'app_route', // the event name
          pageTitle: document.title, // set page title
          pagePath: location.pathname, // set page path
          pageLocation: window.location.href, // set complete url
        });
      }
    });
  }, [history]);

  // Herkunft (gclid, utm_*, Landingpage, Referrer) beim ersten Aufruf merken.
  // Die Werte gehen beim Sign-up mit createUser an den Server (Onboarding) …
  useEffect(() => {
    captureAttribution();
  }, [location.search]);

  // … und werden fuer bestehende Sessions einmal je User nachgetragen; der Server
  // fuellt nur leere Spalten (First Touch gewinnt). Bisher feuerte die Mutation
  // vor der Session und scheiterte zusaetzlich am Admin-Gate, utmParams blieb leer.
  useEffect(() => {
    if (userLoading || !user?.id || isAttributionSynced(user.id)) return;
    const variables = attributionVariables();
    if (Object.keys(variables).length === 0) return;
    markAttributionSynced(user.id);
    updateUtmParams({ variables }).catch((error) => {
      console.error('Error updating attribution:', error);
    });
  }, [user?.id, userLoading, updateUtmParams]);

  useEffect(() => {
    if (!ordervalue || !session_id || conversionTracked || userLoading) return;
    // Convert ordervalue to integer
    const value = parseInt(ordervalue || '0', 10);
    let ga4items = [];
    try {
      ga4items = JSON.parse(items || '[]');
    } catch (e) {
      console.error('Error parsing items: ', items);
    }

    // Function to push the custom event to GA4
    const pushToDataLayer = () => {
      if (window.dataLayer && value) {
        window.dataLayer.push({
          event: 'ga4-event-order-success',
          ordervalue: value / 100,
          email: user?.email,
          items: ga4items,
          session_id,
          item_id: ga4items?.[0]?.item_id,
        });
      }
    };

    // Retry every second until dataLayer is found
    const intervalId = setInterval(() => {
      if (window.dataLayer) {
        pushToDataLayer();
        clearInterval(intervalId); // Clear the interval once the dataLayer is found and event is pushed
      }
    }, 1000);

    setConversionTracked(true); // Mark as tracked
  }, [ordervalue, user, session_id]); // Dependency array to rerun the effect if ordervalue changes

  return null;
}
